// Smooth in-page scrolling for hash links, active only on the article pages (blog post,
// glossary term, guide article — all rendered with <main class="post ...">). Relocated
// from identical inline type="module" scripts in those three templates.

if (document.querySelector('main.post')) {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (event) {
      event.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth',
      });
    });
  });
}
